export const NotFoundScreen = () => {
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-4 px-4 text-center text-muted-foreground">
      <h1 className="text-4xl font-semibold">404</h1>
      <p className="text-lg">ページが見つかりませんでした。</p>
    </main>
  );
};
